<template>
  <router-link v-if="course" tag="div" :to="'/course/' + course.id" class="course-card fill fill-grey fill fill-grey-sm">
    <div>
      <div class="course-card__status-list">
        <div class="course-card__status-list-left">
          <span class="badge bg-dark color-white">
            <template v-if="course.institution">
              {{ course.institution.shortName | truncate(10, '...') }}
            </template>
            <template v-else>
              {{ $t('course.oko') }}
            </template>
          </span>
          <span class="badge bg-yellow">
            {{ course.category ? course.category.title : $t('course.popular')  }}
          </span>
        </div>
        <div class="course-card__status-list-right">
          <span class="badge bg-white">
            {{ getStatusText(course) }}
          </span>
        </div>
      </div>
      <div class="course-card__header">
      <div>
        <div class="course-card__header__cover"
             v-if="typeof course.cover === 'string'"
             :style="{backgroundImage: 'url(' + course.cover + ')'}">
        </div>
        <div class="course-card__header__cover"
             v-else-if="course.cover.thumbs"
             :style="{backgroundImage: 'url(' + getCover(course) + ')'}">
        </div>
      </div>
      <div class="course-card__header__title">
        {{ course.name | truncate(100, '...') }}
      </div>
    </div>
    </div>
    <div class="course-card__description">
      <template v-if="course.shortDescription">
        {{ strippedContent(course.shortDescription) | truncate(200, '...') }}
      </template>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "CourseCard",
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  methods: {
    getCover(course) {
      return course.cover.thumbs.smaller.replace('http://localhost', 'https://universarium.servicecdn.ru')
    },
    strippedContent(content) {
      let regex = /(<([^>]+)>)/ig;
      return content.replace(regex, "");
    },
    getStatusText(course) {
      if (course.status) {
        return this.$t(`course.status.${course.status}`);
      }
      // Fallback для старых данных с statusRu
      if (course.statusRu) {
        // Маппинг русских статусов на ключи
        const statusMap = {
          'Скоро': 'soon',
          'Уже идёт': 'started',
          'Открыт': 'open',
          'Завершен': 'finished',
          'Закрыт': 'closed'
        };
        const statusKey = statusMap[course.statusRu] || 'soon';
        return this.$t(`course.status.${statusKey}`);
      }
      return this.$t('course.status.soon');
    }
  }
}
</script>